<div class="wrapper">
    <main class="middle-content">
        <div class="page_title_block">
            <h1 class="page_title">Chat Management </h1>
        </div>
        <div class="content-section">
            <div class="outer-box">
                <form [formGroup]="searchForm">
                    <div class="d-flex">
                        <div class="col-md-4">
                            <div class="filter_search mb20 width100">
                                <div class="input-group filter_search_group">
                                    <input type="text" class="form-control col-md-6 overflow-text"
                                        formControlName="search" (keyup)="staffListApii()" placeholder="Search by name"
                                        maxlength="60">
                                    <div class="input-group-append">
                                        <button class="btn btn_search_group" style="height: 38px;padding: 6px 10px"
                                            (click)="staffListApii()" type="button">
                                            <img src="assets/img/icon-search.png" alt="Search" />
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-8">
                            <div class="tab-section m-0 row w-100 justify-content-end ">
                                <div class="tab">
                                    <button class="tablinks" [ngClass]="tabView == 'THERAPIST' ? 'active': ''"
                                        (click)="viewTab('THERAPIST')">Chat with Therapist</button>
                                    <button class="tablinks" [ngClass]="tabView == 'SUBADMIN' ? 'active': ''"
                                        (click)="viewTab('SUBADMIN')">Chat with Subadmin</button>
                                    <button class="tablinks mb-4" [ngClass]="tabView == 'PATIENT' ? 'active': ''"
                                        (click)="viewTab('PATIENT')">Chat with Patient</button>

                                </div>
                            </div>
                        </div>
                    </div>
                </form>
            </div>
            <div class="container">
                <div class="messaging">
                    <div class="inbox_msg">
                        <div class="inbox_people">
                            <div class="inbox_chat">
                                @for (therapy of therapistList; track therapy; let i = $index) {
                                <div class="chat_list" [ngClass]="{active_chat : userId == therapy?._id}">
                                    @if(therapy?.firstName){
                                    <div class="chat_people" (click)="chatHistory(therapy?._id)">
                                        <div class="chat_img">
                                            <img src="https://ptetutorials.com/images/user-profile.png" alt="admin"
                                                (error)="onImageError($event)" />
                                        </div>
                                        <div class="chat_ib">
                                            <h5 [ngStyle]="{'color' : userId == therapy?._id ? 'white' : '#464646'}">
                                                {{therapy?.firstName}} {{therapy?.lastName}}</h5>
                                        </div>
                                    </div>
                                    }
                                </div>
                                }
                                @if(!therapistList.length){
                                <div>
                                    <h5 class="userNotFound"> User not found ! </h5>
                                </div>
                                }
                            </div>
                        </div>

                        <!-- style="height: 287px" -->
                        <div class="mesgs">
                            @if(chatHistoryData){
                            <div>
                                @for (msg of chatHistoryData; track msg; let i = $index) {
                                <div class="pb-5">
                                    @for (msgData of msg?.message; track msgData; let j = $index) {
                                    <div class="msg_history">
                                        @if(msgData?.senderId != senderId){
                                        <div class="incoming_msg">
                                            <div class="incoming_msg_img">
                                                <img src="{{msg?.receiverId?.profilePic}}"
                                                    (error)="onImageError($event)" />
                                            </div>
                                            <div class="received_msg">
                                                <div class="received_withd_msg">
                                                    <p>{{msgData?.message}}
                                                    </p>
                                                    <span class="time_date"> {{msgData?.createdAt | date : 'hh:mm a'
                                                        :'UTC'}} |
                                                        {{msgData?.createdAt | date : 'MMM d' :'UTC'}}</span>
                                                </div>
                                            </div>
                                        </div>
                                        }
                                        @if(msgData?.senderId == senderId){
                                        <div class="outgoing_msg">
                                            <div class="sent_msg">
                                                <div class="row d-flex align-items-center">
                                                    <span class="incoming_msg_img">
                                                        <img src="{{msg?.senderId?.profilePic}}"
                                                            (error)="onImageError($event)" />
                                                    </span>
                                                    <div class="col-md-11">
                                                        <p>{{msgData?.message}}
                                                        </p>
                                                    </div>
                                                </div>
                                                <span class="time_date">{{msgData?.createdAt | date : 'hh:mm a' :
                                                    'UTC'}} |
                                                    {{msgData?.createdAt | date : 'MMM d' :'UTC'}}</span>
                                            </div>
                                        </div>
                                        }

                                    </div>
                                    }
                                </div>
                                }
                            </div>
                            }


                            <div class="chatInput">
                                <div class="type_msg mt-3 mb-3">
                                    <div class="input_msg_write">
                                        <input type="text" class="write_msg border form-control"
                                            (keyup.enter)="sendMessage()" [(ngModel)]="message"
                                            placeholder="Type a message" />
                                        <!-- <button class="msg_send_btn1" type="button">
                                            <i class="fa fa-paperclip" aria-hidden="true"></i>
                                        </button> -->
                                        <button class="msg_send_btn" type="button" (click)="sendMessage()"><i
                                                class="fa fa-paper-plane-o" aria-hidden="true"></i></button>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </div>
    </main>
</div>